import { enableableField, MeshKeyMethodVersion } from "@somewear/model";
import {
	baseWorkspaceDeviceDefaultsRequestSchema,
	DEFAULT_WORKSPACE_SETTINGS_VALUES,
	workspaceDefaultsFieldsSchema,
} from "@somewear/workspace";
import { z } from "zod";

export interface OrganizationPickerOption {
	name: string;
	id: string;
}

export const organizationWorkspaceDefaultsSchema = workspaceDefaultsFieldsSchema.extend({
	organizationId: z.string(),
	meshKeyMethodVersion: enableableField(
		z
			.nativeEnum(MeshKeyMethodVersion)
			.default(DEFAULT_WORKSPACE_SETTINGS_VALUES.meshKeyMethodVersion),
		DEFAULT_WORKSPACE_SETTINGS_VALUES.meshKeyMethodVersion !== MeshKeyMethodVersion.UNKNOWN,
	),
});

export const organizationWorkspaceDefaultsRequestSchema =
	baseWorkspaceDeviceDefaultsRequestSchema.extend({
		// Request settings
		organizationId: z.string(),
		meshKeyMethodVersion: z.number(),
	});

export type OrganizationWorkspaceDefaultsSchema = z.infer<
	typeof organizationWorkspaceDefaultsSchema
>;
export type OrganizationWorkspaceDefaultsRequestSchema = z.infer<
	typeof organizationWorkspaceDefaultsRequestSchema
>;
